export default function BrandWatermark() {
  return (
    <div className="fixed bottom-3 right-3 z-40 pointer-events-none select-none" data-testid="brand-watermark">
      <div className="flex items-center rounded-md bg-white/75 backdrop-blur-sm border border-zinc-200/70 shadow-sm px-2 py-1">
        <img src="/jobsmith-logo.png" alt="Jobsmith" className="h-4 w-auto opacity-70" draggable={false} />
      </div>
    </div>
  );
}
